<template>
  <div>
    <form>
      <div class="form-group">
        <label class="control-label">{{
          $t('addministration.expense_item_feature.name_kh')
        }}</label>
        <input
          ref="expense_item_name_kh"
          v-model="model.expense_item_name_kh"
          type="text"
          class="form-control kh-font"
          :class="{ 'is-invalid': errors.has('expense_item_name_kh') }"
          :placeholder="
            $t('addministration.expense_item_feature.enter_name_kh')
          "
        />
        <div class="invalid-feedback" v-if="errors.has('expense_item_name_kh')">
          {{ errors.first('expense_item_name_kh') }}
        </div>
      </div>
      <div class="form-group">
        <label class="control-label"
          >{{ $t('addministration.expense_item_feature.name_en') }}
          <span class="text-danger">*</span>
        </label>
        <input
          v-model="model.expense_item_name_en"
          type="text"
          class="form-control"
          :class="{ 'is-invalid': errors.has('expense_item_name_en') }"
          :placeholder="
            $t('addministration.expense_item_feature.enter_name_en')
          "
        />
        <div class="invalid-feedback" v-if="errors.has('expense_item_name_en')">
          {{ errors.first('expense_item_name_en') }}
        </div>
      </div>
      <div class="form-group">
        <label class="control-label">
          {{ $t('addministration.expense_item_feature.description') }}
        </label>
        <textarea
          v-model="model.description"
          class="form-control"
          :class="{
            'is-invalid': errors.has('description')
          }"
          rows="3"
          :placeholder="
            $t('addministration.expense_item_feature.enter_description')
          "
        ></textarea>
        <div class="invalid-feedback" v-if="errors.has('description')">
          {{ errors.first('description') }}
        </div>
      </div>
      <div class="text-right">
        <ts-button @click="cancel()" v-if="editing == true">
          {{ $t('addministration.expense_item_feature.cancel') }}
        </ts-button>
        <ts-button
          class="ml-2"
          color="primary"
          :disabled="saving"
          :waiting="saving"
          @click="update"
          v-if="editing == true"
        >
          {{ $t('addministration.expense_item_feature.update') }}
        </ts-button>
        <ts-button
          class="ml-2"
          color="primary"
          :disabled="saving"
          :waiting="saving"
          @click="save"
          v-else
        >
          {{ $t('addministration.expense_item_feature.save') }}
        </ts-button>
      </div>
    </form>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'

export default {
  name: 'expense-item-create-form',
  props: ['edit'],
  data() {
    return {
      model: {
        expense_item_name_kh: '',
        expense_item_name_en: '',
        description: ''
      },
      errors: new Errors(),
      saving: false,
      editing: false
    }
  },
  mounted() {
    this.$refs.expense_item_name_kh.focus()
  },
  created() {
    this.setEdit()
  },
  methods: {
    cancel() {
      this.editing = false
      this.clearForm()
      this.$emit('success_update')
      this.$router.push({ name: 'expense-item' })
    },

    async save() {
      this.saving = true
      this.errors = new Errors()
      try {
        let response = await this.$store.dispatch(
          'expenseItem/create',
          this.model
        )
        this.$toasted.success(response.message)
        this.$emit('success_create')
        this.clearForm()
        this.$refs.expense_item_name_kh.focus()
      } catch (error) {
        this.errors = new Errors(error.errors)
        this.$toasted.error(error.message)
      }
      this.saving = false
    },

    async update() {
      this.saving = true
      this.errors = new Errors()
      try {
        let response = await this.$store.dispatch(
          'expenseItem/update',
          this.model
        )

        this.$toasted.success(response.message)
        this.$router.push({ name: 'expense-item' })
        this.editing = false
        this.$emit('success_create')
        this.$emit('success_update')
        this.clearForm()
        this.$refs.expense_item_name_kh.focus()
      } catch (error) {
        this.editing = true
        this.errors = new Errors(error.errors)
        this.$toasted.error(error.message)
      }
      this.saving = false
    },

    setEdit() {
      if (this.edit === null || this.edit === undefined) return

      this.model = Object.assign({}, this.edit)
      this.editing = true
    },

    clearForm() {
      this.model.expense_item_name_kh = ''
      this.model.expense_item_name_en = ''
      this.model.description = ''
    }
  },
  watch: {
    edit: {
      handler() {
        if (this.edit) {
          this.setEdit()
          this.editing = true
        }
      }
    }
  }
}
</script>
